import { useEffect, useRef, useState } from "react";
import { getCandidateInfo } from "../../API/Candidates/Cadidate";
import { getCandidatePresentationValues } from "../../API/Candidates/Presentation";
import { getCandidateProfesionalExperiences } from "../../API/Candidates/Experience";
import { getCandidateFormationValues } from "../../API/Candidates/Education";
import { getPurposeCandidateList } from "../../API/Candidates/Purpose";
import { getCandidateCultureValues } from "../../API/Candidates/Culture";
import { getProfessionalReferencesCandidate } from "../../API/Candidates/References";
import { getCandidateCompetence } from "../../API/Candidates/Competence";
import { getCandidateMotivation } from "../../API/Candidates/Motivation";
import { CompMotThunderIcon, ExpProfArea, ExpProfIndustry, ExpProfTime, ExpProfTimeMedia, FormationIcon, PurposeIcon } from "./Components/CandidateCV/CVIcons";
import CircleProgressBar from "./Components/CandidateCV/CircleProgressBar";
import { HiOutlineMail } from "react-icons/hi";
import { AiFillFacebook, AiOutlineInstagram, AiOutlineLink, AiOutlineLinkedin } from "react-icons/ai";
import Loading from "../../Components/Loading/Loading";

import "./Components/CandidateCV/CandidateCV.sass";
import "bootstrap";
import { Toast, ToastContainer } from "react-bootstrap";
import { useIntl } from "react-intl";
import { candidateCVTranslate } from "../../i18n/translatedMessages";
import { translate } from "../../i18n/messages/Lists/purpose";

var regEx = /%/g;
const CandidateCV = () => {
  const language = useIntl();
  const getLanguage = language.locale === "PT-BR" ? "pt" : "es";

  const templateRef = useRef(null);
  const [candidate, setCandidate] = useState({
    candidateInfo: undefined,
    candidatePres: undefined,
    candidateExp: undefined,
    candidateEdu: undefined,
    candidatePurpose: undefined,
    candidateCult: undefined,
    candidateRef: undefined,
    candidateComp: undefined,
    candidateMot: undefined,
  });
  const [loading, setLoading] = useState(false);
  const [toasty, setToasty] = useState(false);

  const competencesRequests = async () => {
    const id = localStorage.getItem("candidateId");
    const itemCompTemp = await getCandidateCompetence(id);
    const itemComp = itemCompTemp.items ? itemCompTemp?.items[0] : null;

    if (itemComp) {
      let selectedComp = null;

      if (itemComp?.myco?.isActive === true) {
        selectedComp = itemComp.myco;
      } else if (itemComp?.colab?.isActive === true) {
        selectedComp = itemComp.colab;
      }

      if (selectedComp) {
        const competencesAux = {
          analysis_problem_solving: selectedComp.analysis_problem_solving,
          change_management: selectedComp.change_management,
          customer_orientation: selectedComp.customer_orientation,
          innovation: selectedComp.innovation,
          leadership: selectedComp.leadership,
          organization_plan: selectedComp.organization_plan,
          result_orientation: selectedComp.result_orientation,
          self_development: selectedComp.self_development,
          strategic_thinking: selectedComp.strategic_thinking,
          stress_management: selectedComp.stress_management,
          team_work: selectedComp.team_work,
        };

        const compArrAux = Object.entries(competencesAux)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 4);

        return compArrAux;
      }
    }
  };

  const motivationRequest = async () => {
    const id = localStorage.getItem("candidateId");
    const itemMotTemp = await getCandidateMotivation(id);
    const itemMot = itemMotTemp.items ? itemMotTemp.items[0] : null;

    if (itemMot) {
      let selectedMot = null;

      if (itemMot?.myco?.isActive === true) {
        selectedMot = itemMot.myco;
      } else if (itemMot?.colab?.isActive === true) {
        selectedMot = itemMot.colab;
      }

      if (selectedMot) {
        const motivacionsAux = {
          autonomy_versatility: selectedMot.autonomy_versatility,
          business_orientation: selectedMot.business_orientation,
          career: selectedMot.career,
          commitment: selectedMot.commitment,
          conceptual_orientation: selectedMot.conceptual_orientation,
          economic_aspect: selectedMot.economic_aspect,
          innovation_orientation: selectedMot.innovation_orientation,
          job_satisfaction: selectedMot.job_satisfaction,
          management_orientation: selectedMot.management_orientation,
          orientation_interpersonal_relations: selectedMot.orientation_interpersonal_relations,
          orientation_type_work_performed: selectedMot.orientation_type_work_performed,
          prestige: selectedMot.prestige,
          professional_balance: selectedMot.professional_balance,
          professional_proyect: selectedMot.professional_proyect,
          safety: selectedMot.safety,
          skills_development: selectedMot.skills_development,
          target_orientation: selectedMot.target_orientation,
        };

        const motArrAux = Object.entries(motivacionsAux)
          .sort((a, b) => b[1] - a[1])
          .slice(0, 4);

        return motArrAux;
      }
    }
  };

  useEffect(() => {
    const candidateInfo = async () => {
      setLoading(true);
      const id = localStorage.getItem("candidateId");
      const { item } = await getCandidateInfo(id);
      const itemPres = await getCandidatePresentationValues(id);
      const itemExp = await getCandidateProfesionalExperiences(id);
      const itemEdu = await getCandidateFormationValues(id);
      const itemPurpose = await getPurposeCandidateList(id);
      const itemCult = await getCandidateCultureValues(id);
      const itemRef = await getProfessionalReferencesCandidate(id);
      const itemComp = await competencesRequests();
      const itemMot = await motivationRequest();

      setCandidate({
        ...candidate,
        candidateInfo: item && item,
        candidatePres: itemPres && itemPres.items,
        candidateExp: itemExp && itemExp.items?.professional_experiences.sort((a, b) => a.entry_date - b.entry_date),
        candidateEdu: itemEdu && itemEdu.items,
        candidatePurpose: itemPurpose && itemPurpose.items,
        candidateCult: itemCult && itemCult.items,
        candidateRef: itemRef && itemRef.items.professional_references,
        candidateComp: itemComp,
        candidateMot: itemMot,
      });
      setLoading(false);
    };
    candidateInfo();
  }, []);

  const getUnique = (array, key) => {
    if (typeof key !== "function") {
      const property = key;
      key = function (item) {
        return item[property];
      };
    }
    return Array.from(
      array
        .reduce(function (map, item) {
          const k = key(item);
          if (!map.has(k)) map.set(k, item);
          return map;
        }, new Map())
        .values()
    );
  };

  const CalcCandidateExp = () => {
    if (candidate.candidateExp) {
      var date = new Date(candidate.candidateExp[0]?.entry_date);
      let years = new Date().getFullYear() - date.getFullYear();
      let months = new Date().getMonth() + 1 - date.getMonth();

      if (months < 0) {
        months = months * -1;
        years = years - 1;
      }

      return {
        years,
        months,
        yearsMedia: years / candidate.candidateExp?.length,
        monthsMedia: months / candidate.candidateExp?.length,
      };
    }
    return {
      years: 0,
      months: 0,
      yearsMedia: 0,
      monthsMedia: 0,
    };
  };

  const findMaxCulture = () => {
    if (candidate.candidateCult) {
      const arrayAux = [];
      arrayAux.push(Number(candidate.candidateCult?.commercial_percentage.replace(regEx, "")));
      arrayAux.push(Number(candidate.candidateCult?.disruptive_percentage.replace(regEx, "")));
      arrayAux.push(Number(candidate.candidateCult?.collaborative_percentage.replace(regEx, "")));
      arrayAux.push(Number(candidate.candidateCult?.traditional_percentage.replace(regEx, "")));
      return Math.max(...arrayAux);
    }
  };

  const GenerateEmployerXPBar = (data, color) => {
    let n_bars = 1;

    if (data > 0) {
      n_bars = Math.ceil(data);
      n_bars = n_bars > 4 ? 4 : n_bars;
    } else if (data > 20) {
      n_bars = 4;
    }
    const enabled_bars = [];
    for (let index = 0; index < n_bars; index++) {
      enabled_bars.push(<div key={index} className={color === "blue" ? "slotBlue slotFillBlue d-inline-block" : "slotPurple slotFillPurple d-inline-block"}></div>);
    }

    const disabled_bars = [];
    for (let index = 0; index < 4 - n_bars; index++) {
      disabled_bars.push(<div key={index} className={color === "blue" ? "slotBlue d-inline-block" : "slotPurple d-inline-block"}></div>);
    }

    return (
      <>
        {enabled_bars}
        {disabled_bars}
      </>
    );
  };

  const handleLink = () => {
    const link = `${window.location.origin}/profile/overview/${candidate?.candidateInfo?.hash_profile}`;
    window.open(link, "_blank");
    setToasty(!toasty);
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <ToastContainer className="p-3" position={"bottom-end"} style={{ zIndex: 1 }}>
            <Toast onClose={() => setToasty(false)} position="bottom-end" show={toasty} delay={3000} autohide>
              <Toast.Body>Link copiado</Toast.Body>
            </Toast>
          </ToastContainer>
          <div className="container CandidateCVMain" ref={templateRef}>
            <div className="row borderPurple borderRounded p-4 gap-3 gap-xl-0 bgWhite">
              <div className="col-xl-2">
                <img
                  className="img-fluid rounded-circle candidateImage"
                  src={candidate?.candidateInfo?.image || "https://assets.mydna.company/b2b-images/image_default.png"}
                  alt=""
                />
              </div>
              <div className="col-xl-7">
                <h3 className="fw-bolder textDarkPurple">{candidate?.candidateInfo?.name}</h3>
                <h5 className="textWhitePurple">{candidate?.candidateInfo?.jobname}</h5>
                <p className="textWhitePurple mb-0">
                  {candidate?.candidateInfo?.country}
                  {candidate?.candidateInfo?.country && candidate?.candidateInfo?.address ? " - " : ""}
                  {candidate?.candidateInfo?.address}
                </p>
                <p>{candidate?.candidateInfo?.phone}</p>
                <div className="mt-3">
                  {candidate?.candidateInfo?.areas?.map((item, key) => {
                    return (
                      <div className="d-inline-block bgBlue borderBlue rounded-pill me-2 px-3 py-1" key={key}>
                        {" "}
                        #{item}{" "}
                      </div>
                    );
                  })}
                </div>
                <p className="mt-3 mb-0">{candidate?.candidatePres?.about_me}</p>
              </div>
              <div className="col-xl-2">
                <ul className="list-group list-group-horizontal wheelEmployeePage-list">
                  <li className="list-group-item px-2 py-2 border-0">
                    <a href={candidate.candidateInfo?.mail ? "mailto:" + candidate.candidateInfo?.mail : null} target="_blank" rel="noreferrer">
                      <HiOutlineMail size={35} color={candidate.candidateInfo?.mail ? "#7A6BE8" : "#D9D9E2"} />
                    </a>
                  </li>
                  <li className="list-group-item px-2 py-2 border-0">
                    <a href={candidate.candidateInfo?.network?.linkedin ? candidate.candidateInfo?.network?.linkedin : null} target="_blank" rel="noreferrer">
                      <AiOutlineLinkedin size={35} color={candidate.candidateInfo?.network?.linkedin ? "#7A6BE8" : "#D9D9E2"} />
                    </a>
                  </li>
                  <li className="list-group-item px-2 py-2 border-0">
                    <a href={candidate.candidateInfo?.network?.facebook ? candidate.candidateInfo?.network?.facebook : null} target="_blank" rel="noreferrer">
                      <AiFillFacebook size={35} color={candidate.candidateInfo?.network?.facebook ? "#7A6BE8" : "#D9D9E2"} />
                    </a>
                  </li>
                  <li className="list-group-item px-2 pb-2 border-0">
                    <a href={candidate.candidateInfo?.network?.instagram ? candidate.candidateInfo?.network?.instagram : null} target="_blank" rel="noreferrer">
                      <AiOutlineInstagram size={35} color={candidate.candidateInfo?.network?.instagram ? "#7A6BE8" : "#D9D9E2"} />
                    </a>
                  </li>
                </ul>
                <button className="btn mt-3 btnSharePDF p-1 pe-2" onClick={() => handleLink()}>
                  <AiOutlineLink size={25} color={"#7A6BE8"} /> {candidateCVTranslate.shareButtonCV}
                </button>
              </div>
            </div>

            {/* EXPERIENCIAS */}
            <div className="row pt-5 gap-3 gap-xl-0">
              <div className="col-xl-4">
                <h4 className="fw-bolder h3 pb-4">{candidateCVTranslate.professionalExperienceCV}</h4>
                {candidate?.candidateExp ? (
                  <>
                    <div className="row align-items-center pb-4">
                      <div className="col-auto">
                        <ExpProfTime width="20" />
                      </div>
                      <div className="col-auto">
                        <h5 className="m-0">
                          {!isNaN(CalcCandidateExp()?.years)
                            ? CalcCandidateExp()?.years >= 1
                              ? CalcCandidateExp()?.years +
                                (language.locale === "PT-BR" ? " ano(s) " : " año(s) ") +
                                (CalcCandidateExp()?.months >= 1
                                  ? (language.locale === "PT-BR" ? " e " : " y ") + CalcCandidateExp()?.months + (language.locale === "PT-BR" ? " mês(es)" : " mes(es)")
                                  : "") +
                                (language.locale === "PT-BR" ? " de carreira" : " de carrera")
                              : !isNaN(CalcCandidateExp()?.months)
                              ? CalcCandidateExp()?.months + (language.locale === "PT-BR" ? "mês(es) de carreira" : "mes(es) de carrera")
                              : ""
                            : ""}
                        </h5>
                      </div>
                    </div>
                    <div className="row align-items-center pb-4">
                      <div className="col-auto">
                        <ExpProfArea width="20" />
                      </div>
                      <div className="col-auto">
                        <h5 className="m-0">
                          {candidate?.candidateExp &&
                            getUnique(candidate?.candidateExp, "jobname")
                              ?.slice(0, 3)
                              .map((exp, key) => {
                                return (
                                  <span key={key}>
                                    {key !== 0 && " "} {exp.jobname} {getUnique(candidate?.candidateExp, "jobname")?.slice(0, 3).length - 1 !== key ? " |" : ""}
                                  </span>
                                );
                              })}
                        </h5>
                      </div>
                    </div>

                    <div className="row align-items-center pb-4">
                      <div className="col-auto">
                        <ExpProfIndustry width="20" />
                      </div>
                      <div className="col-auto">
                        <h5 className="m-0">
                          {candidate?.candidateExp &&
                            getUnique(candidate?.candidateExp, "industry.text")
                              ?.slice(0, 3)
                              .map((industryTp, key) => {
                                return (
                                  <span key={key}>
                                    {key !== 0 && " "} {industryTp?.industry.text} {getUnique(candidate?.candidateExp, "industry.text")?.slice(0, 3).length - 1 !== key && " |"}
                                  </span>
                                );
                              })}
                        </h5>
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <div className="col-auto">
                        <ExpProfTimeMedia width="20" height="21" />
                      </div>
                      <div className="col-auto">
                        <h5 className="m-0">
                          {!isNaN(CalcCandidateExp()?.years)
                            ? CalcCandidateExp()?.years >= 1
                              ? CalcCandidateExp()?.yearsMedia?.toFixed(2) + (language.locale === "PT-BR" ? " ano(s) de empresa" : " año(s) por empresa")
                              : !isNaN(CalcCandidateExp()?.months)
                              ? CalcCandidateExp()?.monthsMedia?.toFixed(2) + language.locale === "PT-BR"
                                ? " mês(es) por empresa"
                                : " mes(es) por empresa"
                              : ""
                            : ""}
                        </h5>
                      </div>
                    </div>
                  </>
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
              <div className="col-xl-3">
                <h4 className="fw-bolder h3 pb-4">{candidateCVTranslate.formationCV}</h4>
                {candidate.candidateEdu?.formacions ? (
                  candidate.candidateEdu?.formacions?.slice(candidate.candidateEdu?.length - 4).map((item, key) => {
                    return (
                      <div className="pb-3 row" key={key}>
                        <div className="col-auto">
                          <FormationIcon color="#27E6C4" width="20" height="21" />
                        </div>
                        <div className="col-auto">
                          <h5 className="align-items-center m-0">{item?.university}</h5>
                          <p className="m-0 p-0 text-muted h6">{item?.name}</p>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
              <div className="col-xl-5">
                <h4 className="fw-bolder h3 pb-4">{candidateCVTranslate.purposeCV}</h4>
                {candidate.candidatePurpose ? (
                  candidate.candidatePurpose?.slice(0, 5).map((item, key) => {
                    return (
                      <div className="row align-items-center pb-4" key={key}>
                        <div className="col-auto">
                          <PurposeIcon color="#78D7FF" width="20" height="21" />
                        </div>
                        <div className="col-auto">
                          <h5 className="m-0">{translate[getLanguage][item.name]}</h5>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
            </div>

            {/* CULTURA */}
            <div className="row mt-4 pt-5 border-top gap-3 gap-xl-0">
              <div className="col-xl-6">
                <h4 className="h3 pb-4 fw-bolder">{candidateCVTranslate.cultureCV}</h4>
                {candidate.candidateCult ? (
                  <div className="row">
                    {findMaxCulture() === Number(candidate.candidateCult?.commercial_percentage.replace(regEx, "")) ? (
                      <div className="col-7">
                        <h4 className="textPrimary fw-bold h3">Comercial</h4>
                        <p>
                          {language.locale === "PT-BR"
                            ? "Orientação para alcançar resultados. O ambiente motiva parcialmente os colaboradores para cumprir metas. O estilo de liderança motiva, mas você pode colocar mais agressividade comercial."
                            : "Orientación a lograr resultados. Ambiente motiva en parte a colaboradores a cumplir metas. Estilo de liderazgo motiva, pero se puede poner mas agresividad comercial."}
                        </p>
                      </div>
                    ) : findMaxCulture() === Number(candidate.candidateCult?.disruptive_percentage.replace(regEx, "")) ? (
                      <div className="col-7">
                        <h4 className="textPrimary fw-bold h3">Disruptiva</h4>
                        <p>
                          {language.locale === "PT-BR"
                            ? "Estilo organizacional mais inovador, você ouve e trabalha mais equipamento. Está planejado mais para o longo prazo. Liderança é mais motivadora, assumir riscos, mais empreendedor."
                            : "Estilo de organización más innovadora, se escucha y se trabaja más en equipo. Se planifica más a largo plazo. El liderazgo es más motivador, de tomar riesgos, más emprendedor."}
                        </p>
                      </div>
                    ) : findMaxCulture() === Number(candidate.candidateCult?.traditional_percentage.replace(regEx, "")) ? (
                      <div className="col-7">
                        <h4 className="textPrimary fw-bold h3">Tradicional</h4>
                        <p>
                          {language.locale === "PT-BR"
                            ? "Estilo de organização com foco nas pessoas. Preocupado em gerar ambiente de trabalho agradável e próximo. O desenvolvimento profissional faz parte desafios permanentes."
                            : "Estilo de organización con foco en las personas. Preocupados de generar un ambiente de trabajo grato y cercano. El desarrollo profesional es parte de los desafíos permanentes."}
                        </p>
                      </div>
                    ) : findMaxCulture() === Number(candidate.candidateCult?.collaborative_percentage.replace(regEx, "")) ? (
                      <div className="col-7">
                        <h4 className="textPrimary fw-bold h3">Colaborativa</h4>
                        <p>
                          {language.locale === "PT-BR"
                            ? "Estilo de organização levemente estruturado. Tem um estrutura de pirâmide, onde as decisões são tomadas por poucos. O a comunicação de decisões ou estratégias é lenta, conhecida por poucos e geralmente sede."
                            : "Estilo de organización levemente estructurado. Se cuenta con una estructura piramidal, donde las decisiones son tomadas por pocos. La comunicación de las decisiones o estrategia es lenta, conocida por pocos y generalmente jefaturas."}
                        </p>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="col-auto">
                      <CircleProgressBar porcentage={Math.round(findMaxCulture() || 0)} />
                    </div>
                  </div>
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
              <div className="col-xl-6">
                <h4 className="h3 pb-4 fw-bolder">{candidateCVTranslate.knowledgeCV}</h4>
                {candidate.candidateEdu ? (
                  <>
                    <h4 className="textDarkPurple fw-bold h3">{candidateCVTranslate.languagesCV}</h4>
                    {candidate.candidateEdu?.languages?.length > 0 ? (
                      candidate.candidateEdu?.languages?.slice(0, 2).map((item, key) => {
                        return (
                          <div className="pb-3 row" key={key}>
                            <div className="col-auto">
                              <FormationIcon color="#27E6C4" width="20" height="21" />
                            </div>
                            <div className="col-auto">
                              <h5 className="m-0 fw-bold">{item?.language}</h5>
                              {GenerateEmployerXPBar(item?.language_level_id)}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="row align-items-center pb-4 px-3">
                        <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                      </div>
                    )}
                    <h4 className="textBlue fw-bold h3">{candidateCVTranslate.abilitiesCV}</h4>

                    {candidate.candidateEdu?.skills?.length > 0 ? (
                      candidate.candidateEdu?.skills?.slice(0, 2).map((item, key) => {
                        return (
                          <div className="pb-3 row" key={key}>
                            <div className="col-auto">
                              <FormationIcon color="#27E6C4" width="20" height="21" />
                            </div>
                            <div className="col-auto">
                              <h5 className="m-0 fw-bold">{item?.name}</h5>
                              {GenerateEmployerXPBar(item?.skill_level_id, "blue")}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="row align-items-center pb-4 px-3">
                        <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                      </div>
                    )}
                  </>
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
            </div>

            {/* COMPETENCIAS E MOTIVACIONES */}
            <div className="row pt-5 mt-4 border-top gap-3 gap-xl-0">
              <div className="col-xl-6">
                <h4 className="h3 pb-4 fw-bolder">{candidateCVTranslate.abilitiesCV}</h4>
                {candidate.candidateComp?.length > 0 ? (
                  candidate.candidateComp?.map((comp, key) => {
                    return (
                      <div className="row py-2 align-items-top" key={key}>
                        <div className="col-auto">
                          <CompMotThunderIcon height="22" />
                        </div>
                        <div className="col-11">
                          <h5>
                            {comp[0] === "analysis_problem_solving"
                              ? language.locale === "PT-BR"
                                ? "Análise e Resolução de Problemas"
                                : "Análisis y Resolución de Problemas"
                              : comp[0] === "innovation"
                              ? language.locale === "PT-BR"
                                ? "Inovação"
                                : "Innovación"
                              : comp[0] === "strategic_thinking"
                              ? language.locale === "PT-BR"
                                ? "Visão Estatégica"
                                : "Visión Estratégica"
                              : comp[0] === "customer_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação ao Cliente"
                                : "Orientación al Cliente"
                              : comp[0] === "team_work"
                              ? language.locale === "PT-BR"
                                ? "Trabalho em Equipe"
                                : "Trabajo en Equipo"
                              : comp[0] === "leadership"
                              ? language.locale === "PT-BR"
                                ? "Liderança"
                                : "Liderazgo"
                              : comp[0] === "result_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação a Resultados"
                                : "Orientación a Resultados"
                              : comp[0] === "organization_plan"
                              ? language.locale === "PT-BR"
                                ? "Plan. e Org."
                                : "Plan. Y Org."
                              : comp[0] === "change_management"
                              ? language.locale === "PT-BR"
                                ? "Gestão de Mudança"
                                : "Gestión del cambio"
                              : comp[0] === "self_development"
                              ? language.locale === "PT-BR"
                                ? "Auto Desenvolvimento"
                                : "Auto Desenvolvimento"
                              : comp[0] === "stress_management"
                              ? language.locale === "PT-BR"
                                ? "Gerenciamento de Estresse"
                                : "Gestión del Estrés"
                              : ""}
                          </h5>
                          <div className="progress">
                            <div
                              className="progress-bar bg-green text-black"
                              role="progressbar"
                              style={{
                                width: `${comp[1] * 10}%`,
                              }}
                            >
                              {comp[1]} / 10
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
              <div className="col-xl-6">
                <h4 className="h3 pb-4 fw-bolder">{candidateCVTranslate.motivationsCV}</h4>
                {candidate.candidateMot?.length > 0 ? (
                  candidate.candidateMot?.map((comp, key) => {
                    return (
                      <div className="row align-items-top py-2" key={key}>
                        <div className="col-auto">
                          <CompMotThunderIcon height="22" />
                        </div>
                        <div className="col-11">
                          <h5>
                            {comp[0] === "business_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação Comercial"
                                : "Orientación Comercial"
                              : comp[0] === "target_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação ao Objetivo"
                                : "Orientación al objetivo"
                              : comp[0] === "orientation_type_work_performed"
                              ? language.locale === "PT-BR"
                                ? "Orientação a Tipologia do Trabalho Realizado"
                                : "Orientación a la Tipología del Trabajo Realizado"
                              : comp[0] === "innovation_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação a Inovação"
                                : "Orientación a la innovación"
                              : comp[0] === "economic_aspect"
                              ? language.locale === "PT-BR"
                                ? "Aspecto Econômico"
                                : "Aspecto Económico"
                              : comp[0] === "autonomy_versatility"
                              ? language.locale === "PT-BR"
                                ? "Autonomia e Versatilidade"
                                : "Autonomía y Versatilidad"
                              : comp[0] === "safety"
                              ? language.locale === "PT-BR"
                                ? "Segurança"
                                : "Seguridad"
                              : comp[0] === "prestige"
                              ? language.locale === "PT-BR"
                                ? "Prestígio"
                                : "Prestigio"
                              : comp[0] === "professional_balance"
                              ? language.locale === "PT-BR"
                                ? "Balanço Profissional"
                                : "Balance Profesional"
                              : comp[0] === "job_satisfaction"
                              ? language.locale === "PT-BR"
                                ? "Satisfação com o Posto"
                                : "Satisfacción con el puesto"
                              : comp[0] === "commitment"
                              ? language.locale === "PT-BR"
                                ? "Compromisso"
                                : "Compromiso"
                              : comp[0] === "career"
                              ? language.locale === "PT-BR"
                                ? "Carreira"
                                : "Carrera"
                              : comp[0] === "skills_development"
                              ? language.locale === "PT-BR"
                                ? "Desenvolvimento de Competências"
                                : "Desarrollo de Competencias"
                              : comp[0] === "professional_proyect"
                              ? language.locale === "PT-BR"
                                ? "Projeto Profissional"
                                : "Proyecto Profesional"
                              : comp[0] === "orientation_interpersonal_relations"
                              ? language.locale === "PT-BR"
                                ? "Orientação as Rel. Interpessoais"
                                : "Orientación a las Rel. Interpersonales"
                              : comp[0] === "conceptual_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação Conceitual"
                                : "Orientación Conceptual"
                              : comp[0] === "management_orientation"
                              ? language.locale === "PT-BR"
                                ? "Orientação a Gestão"
                                : "Orientación a la gestión"
                              : ""}
                          </h5>
                          <div className="progress">
                            <div
                              className="progress-bar bg-green text-black"
                              role="progressbar"
                              style={{
                                width: `${comp[1] * 10}%`,
                              }}
                            >
                              {comp[1]} / 10
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <div className="row align-items-center pb-4 px-3">
                    <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                  </div>
                )}
              </div>
            </div>

            {/* HISTORICO PROFISSIONAL */}
            <div className="row pt-5 mt-4 border-top gap-3 gap-xl-0">
              <h4 className="h3 pb-4 fw-bolder">{candidateCVTranslate.professionalHistoricCV}</h4>
              {candidate?.candidateExp?.length > 0 ? (
                <>
                  <div className="row gap-3 gap-xl-0">
                    {candidate?.candidateExp?.slice(0, 2).map((item, key) => {
                      return (
                        <div key={key} className="col-xl-6">
                          <div className="expBox border p-3">
                            <h4 className="textDarkPurple fw-bold h3">{item.jobname}</h4>
                            <h5 className="textPrimary fw-bold h5">{item.company}</h5>
                            <p className="textWhitePurple">
                              {item.entry_date} ~ {item.departure_date}
                            </p>
                            <h5 className="textPrimary fw-bold h5">{candidateCVTranslate.functionsCV}</h5>
                            {item.description}
                            <h5 className="textPrimary fw-bold h5 pt-3">{candidateCVTranslate.achiviementsCV}</h5>
                            {item.achievements}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div className="row pt-3 gap-3 gap-xl-0">
                    {candidate?.candidateExp?.slice(2, 5)?.map((item, key) => {
                      return (
                        <div key={key} className="col-xl-4">
                          <div className="expBox border p-3">
                            <h4 className="textDarkPurple fw-bold h3">{item.jobname}</h4>
                            <h5 className="textPrimary fw-bold h5">{item.company}</h5>
                            <span className="textWhitePurple">
                              {item.entry_date} ~ {item.departure_date === "Actual" ? (language.locale === "PT-BR" ? "Atual" : "Actual") : item.departure_date}
                            </span>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </>
              ) : (
                <div className="row align-items-center pb-4 px-3">
                  <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                </div>
              )}
            </div>

            {/* REFERENCIAS */}
            <div className="row pt-5 mt-4 pb-5 border-top gap-3 gap-xl-0">
              <h4 className="h3 pb-4 fw-bolder">Referencias</h4>
              {candidate?.candidateRef?.length > 0 || null ? (
                candidate?.candidateRef?.slice(0, 2).map((item, key) => {
                  return (
                    <div key={key} className="col-xl-6">
                      <div className="border expBox p-3">
                        <h4 className="textDarkPurple fw-bold h3">{item.name}</h4>
                        <h5 className="textWhitePurple fw-bold h5">{item.level}</h5>
                        <h6 className="fw-bold h6">
                          {item.company && item.company}
                          {item.relation && item.company ? " - " : " "}
                          {item.relation && item.relation}
                        </h6>
                        {item.email && item.email}
                        {item.phone && item.email ? " - " : " "}
                        {item.phone && item.phone}
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="row align-items-center pb-4 px-3">
                  <div className="col bg-grey py-2 text-center rounded">{candidateCVTranslate.emptyValueCV}</div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CandidateCV;
